import { Controller } from "@hotwired/stimulus"

const DRAGGING_CLASS = "app-file-drop--dragging"

export default class extends Controller {
  static targets = ["input", "picker", "status"]

  connect() {
    this.emptyStatus = this.statusTarget.innerHTML
    this.inputTarget.hidden = true
    this.pickerTarget.hidden = false
    this.update()
  }

  choose(event) {
    if (event.target === this.inputTarget) return

    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add(DRAGGING_CLASS)
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.element.classList.remove(DRAGGING_CLASS)
    }
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove(DRAGGING_CLASS)

    if (event.dataTransfer.files.length > 0) {
      this.inputTarget.files = event.dataTransfer.files
      this.update()
    }
  }

  update() {
    const files = Array.from(this.inputTarget.files)

    if (files.length === 0) {
      this.statusTarget.innerHTML = this.emptyStatus
      return
    }

    const list = document.createElement("ul")
    list.className = "govuk-list govuk-!-margin-bottom-0"

    for (const file of files) {
      const item = document.createElement("li")
      item.textContent = file.name
      list.append(item)
    }

    this.statusTarget.replaceChildren(list)
  }
}
